export default __webpack_public_path__ + "static/media/drogontiger.37635388.jpg";